import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CustomersList from './CustomersList';
import CustomerForm from './CustomerForm';
import CustomerDetail from './CustomerDetail';

const CustomerRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<CustomersList />} />
      <Route path="/create" element={<CustomerForm />} />
      <Route path="/:id" element={<CustomerDetail />} />
      <Route path="/:id/edit" element={<CustomerForm />} />
    </Routes>
  );
};

export default CustomerRoutes;
